import { Apollo_gql, GraphQueryPayload, graphQlTake } from '@camelot/server';

export function GET_DEPARTMENTS(where: string, props: string, take?: number): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query Departments {
        departments(${where}, ${graphQlTake(take)}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}

export function GET_COMPANIES(where: string, props: string, take?: number): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query Companies {
        companies(${where}, ${graphQlTake(take)}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}

export function GET_ACTIVITIES(where: string, props: string, take?: number): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query Activities {
        activities(${where}, ${graphQlTake(take)}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}
